import { useEffect, useState } from 'react';
import { IWatrRequest } from '@nkr/models/index';
import { FormControl, Button, ControlLabel, ToggleButtonGroup, ToggleButton, Modal, FormGroup, Form, Well, Panel } from 'react-bootstrap';
import usePrevious from '@nkr/services/use-previous';
import ReactHtmlParser from 'react-html-parser'
import { ApprovalEmailType } from '@nkr/enums/approval-email-type';

interface IProps {
    show: boolean,
    data: IWatrRequest,
    approvalEmailType: ApprovalEmailType,
    onApproval: (requestId: number, emailSubject: string, firstParagraph: string, emailContent: string) => void,
    onClose: () => void,
}

const ApprovalEmail = (props: IProps) => {
    const [emailSubject, setEmailSubject] = useState('');
    const [emailContent, setEmailContent] = useState('');
    const [firstParagraph, setFirstParagraph] = useState('');

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            if (props.data != null) {
                let newEmailSubject = `Donor Shield ${getReimbursementTyoe()} Reimbursement - Request Approved`;

                let first = `Dear ${props.data.firstName}, <br/><br/> Your request for ${getReimbursementTyoe()} Reimbursement has been approved with the following changes: <br/><br/>`;

                setFirstParagraph(first);
                setEmailContent('');
                setEmailSubject(newEmailSubject);
            }
        }
    }, [props.show, props.data]);

    const getReimbursementTyoe = () => {
        switch (props.approvalEmailType) {
            case ApprovalEmailType.VerifyPayStub:
            case ApprovalEmailType.VerifyTax:
                return 'Lost Wage';
            default:
                return 'Expense';
        }
    }

    const handleInputChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (name == 'emailSubject') {
            setEmailSubject(value);
        }

        if (name == 'emailContent') {
            setEmailContent(value);
        }
    };

    const handleApprove = () => {
        props.onApproval(props.data.id, emailSubject, firstParagraph, emailContent.replace(/\n/g, '|'));
    }

    if (props.data == null)
        return null;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Approval Modifications for {props.data.firstName + ' ' + props.data.lastName}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <FormGroup>
                    <ControlLabel>Email Subject</ControlLabel>
                    <FormControl
                        name='emailSubject'
                        id='EmailSubject'
                        value={emailSubject}
                        onChange={handleInputChange} />
                </FormGroup>

                <Well bsSize='sm'>
                    <FormGroup>
                        <ControlLabel>Email Content</ControlLabel>
                        <div style={{ marginBottom: 5 }} className='form-control-static'>
                            {ReactHtmlParser(firstParagraph)}
                        </div>

                        <FormControl
                            componentClass='textarea'
                            placeholder='Type your message here...'
                            name='emailContent'
                            value={emailContent}
                            style={{ height: '200px' }}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Well>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleApprove}>Send Approval Update</Button>
                <Button onClick={props.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ApprovalEmail;